import gql from 'graphql-tag';

export const getChannel = gql`
  fragment PublicUserFragment on PublicUser {
    _id
    _created
    name
    online
    lastSeen

    role {
      _id
      name
      description
      groupRoleName
    }

    profile {
      _id
      name
      phone
      email
      logo
      image
    }
  }

  fragment TypographyLayoutElementFragment on TypographyLayoutElement {
    _id
    fontFamily
    fontWeight
    fontSize
    lineHeight
    letterSpacing
    marginTop
    marginRight
    marginBottom
    marginLeft
    paddingTop
    paddingRight
    paddingBottom
    paddingLeft
  }

  fragment ThemeFragment on Theme {
    _id
    _created
    _updated
    name
    user {
      _id
    }
    channel {
      _id
    }
    palette {
      _id
      name
      primary
      secondary
      tertiary
      text
      background
      custom {
        _id
        name
        color
      }
    }

    typography {
      _id
      base {
        ...TypographyLayoutElementFragment
      }
      h1 {
        ...TypographyLayoutElementFragment
      }
      h2 {
        ...TypographyLayoutElementFragment
      }
      h3 {
        ...TypographyLayoutElementFragment
      }
      h4 {
        ...TypographyLayoutElementFragment
      }
      h5 {
        ...TypographyLayoutElementFragment
      }
      h6 {
        ...TypographyLayoutElementFragment
      }
      p {
        ...TypographyLayoutElementFragment
      }
      label {
        ...TypographyLayoutElementFragment
      }
      quote {
        ...TypographyLayoutElementFragment
      }
      strong {
        ...TypographyLayoutElementFragment
      }
      emphasis {
        ...TypographyLayoutElementFragment
      }
    }
    layout {
      _id
      marginTop
      marginRight
      marginBottom
      marginLeft
      paddingTop
      paddingRight
      paddingBottom
      paddingLeft
    }
  }

  fragment FullProfileWithThemeFragment on Profile {
    _id
    _created
    _updated
    name
    description
    email
    phone
    noReplyEmail
    backgroundImage
    image
    logo
    wordmark
    color
    backgroundColor
    theme {
      ...ThemeFragment
    }

    content {
      _id
      _created
      _updated
      name
      description
      subtitle
      slug
      type
      tags
      data
      liveDate
      startDate
      endDate
      unpublishDate
      category
      logo
      color
      geo
      block
      isInteractive
      backgroundImage
      icon
      iconSet
      iconWeight
      backgroundColor
      version
      renderer
      card {
        _id
      }
    }
  }

  fragment AddressFragment on Address {
    _id
    _created
    _updated
    _order
    name
    street1
    street2
    street3
    city
    state
    code
    country
    geo
  }

  fragment SectionFragment on Section {
    _id
    _created
    _updated
    name
    name_l10n
    channel {
      _id
      settings {
        multiLanguageEnabled
        channelLanguages
        enabledLanguagesForMembers
      }
    }
    description
    type
    query
    tags
    backgroundImage
    backgroundColor
    icon
    iconSet
    iconWeight
    logo
    color
    filters
    sorts
    groupBy
  }

  query getChannel($id: UUID, $slug: String) {
    channel(_id: $id, slug: $slug) {
      _id
      _created
      _updated
      _createdBy {
        ...PublicUserFragment
      }
      _updatedBy {
        ...PublicUserFragment
      }

      name
      website
      description
      slug
      type
      experienceType
      isPublic
      isDiscoverable
      isLive
      isSub
      inviteOnly
      restrictPropertyAccess
      propertyLevelDomainControl
      filters
      tags

      settings {
        hasPerksEnabled
        hasWorkOrdersEnabled
        hasWorkOrderServiceRequestsEnabled
        hasWorkOrderPreventiveMaintenanceEnabled
        hasWorkOrderEquipmentEnabled
        hasVisitorManagementEnabled
        hasBillingPaymentsEnabled
        multiLanguageEnabled
        channelLanguages
        enabledLanguagesForMembers
        hasHardwareManagementEnabled
        hasHardwarePinManagementEnabled
        hasReservableManagementEnabled
        hasSurveysEnabled
        hasWorkOrderCrossPropertyEnabled
        hasSmartUserManagementEnabled
        hasAccessControlEnabled
        hasMessagingAndMarketplaceEnabled
        areUserTemplatesAllowed
        subscribersJoinParent
        subscribersAreDecoyed
        groupRoleJoinRules {
          _id
          groupRoleId
          joinGroupRoleId
          channelId
        }
      }

      address {
        ...AddressFragment
      }

      profile {
        ...FullProfileWithThemeFragment
      }

      parent {
        _id
        name
        slug
      }

      pages {
        _id
        _order
        _created
        _updated
        content {
          _id
          _created
          _updated
        }
        name
        slug
        icon
        iconSet
        label
        label_l10n
      }

      team {
        _id
        name
        users {
          ...PublicUserFragment
        }
      }

      sections {
        ...SectionFragment
      }
    }
  }
`;